module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( i18n.tc("UnitDelete", "Remove Bluetooth device") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc( "UnitDelete", "Are you sure you want to remove the device %s?" ).format(alias) ))==null?'':__t)+
'</p><fieldset class="button-wrap"><button data-click="unit-cancel">'+
((__t=( i18n.tc("UnitDelete", "Cancel") ))==null?'':__t)+
'</button> <button class="danger" data-click="unit-submit">'+
((__t=( i18n.tc("UnitDelete", "Remove") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
